import { render, staticRenderFns } from "./platticketpro.vue?vue&type=template&id=27b26ec0&scoped=true&"
import script from "./platticketpro.vue?vue&type=script&lang=js&"
export * from "./platticketpro.vue?vue&type=script&lang=js&"
import style0 from "./platticketpro.vue?vue&type=style&index=0&id=27b26ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b26ec0",
  null
  
)

export default component.exports